var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import * as go from '../../../libs/gojs/release/go';
import * as _ from 'lodash';
import { DiagramConsts } from './diagram-consts';
import { ElementFactory } from './elements/base/element.factory';
import { DiagramEx } from './diagram-ex';
var DiagramCompileService = /** @class */ (function () {
    function DiagramCompileService(templateService, layerService) {
        this.templateService = templateService;
        this.layerService = layerService;
        this.compileDiagramDivId = 'compile-diagram';
    }
    DiagramCompileService.prototype.build = function (modelJSON, width, height, variables) {
        var diagram;
        var diagramDiv = document.getElementById(this.compileDiagramDivId);
        if (null == diagramDiv) {
            diagramDiv = document.createElement('div');
            diagramDiv.id = this.compileDiagramDivId;
            diagramDiv.style.width = '0px';
            diagramDiv.style.height = '0px';
            document.body.appendChild(diagramDiv);
            diagram = new DiagramEx(this.compileDiagramDivId, width, height, modelJSON, this.templateService, this.layerService);
        }
        else {
            diagram = go.Diagram.fromDiv(diagramDiv);
            diagram.fixedBounds = new go.Rect(0, 0, width, height);
            diagram.model = DiagramEx.getDiagramModel(modelJSON);
        }
        DiagramConsts.compilerUsedVariables = variables;
        var svgElement = diagram.makeSvg({
            scale: 1,
            position: new go.Point(1, 1),
            size: new go.Size(width, height),
            elementFinished: this.elementFinished
        });
        $(svgElement).attr('data-model', JSON.stringify(diagram.getViewSettings()));
        return new XMLSerializer().serializeToString(svgElement);
    };
    DiagramCompileService.prototype.getVariableNames = function (nodeDataArray) {
        var _this = this;
        var variableNames = new Array();
        _.forEach(nodeDataArray, function (nodeData) {
            var nodeDataVariableNames = _this.getElementVariableNames(nodeData);
            if (null != nodeDataVariableNames && nodeDataVariableNames.length > 0) {
                _.forEach(nodeDataVariableNames, function (variableName) { return variableNames.push(variableName); });
            }
        });
        variableNames = _.uniq(variableNames);
        return variableNames;
    };
    DiagramCompileService.prototype.getElementVariableNames = function (nodeData) {
        switch (nodeData.category) {
            case DiagramConsts.elements.numericalDisplayKey:
                return [nodeData.variableName];
            case DiagramConsts.elements.switchIndicatorLightKey:
                var variableNames = new Array();
                if (nodeData.useSwitch && nodeData.switchSettings && nodeData.switchSettings.settings) {
                    var variableName = nodeData.switchSettings.settings.variableName;
                    if (null != variableName && variableName.length > 0) {
                        variableNames.push(variableName);
                    }
                }
                if (nodeData.useIndicatorLight && nodeData.indicatorLightSettings && nodeData.indicatorLightSettings.settings) {
                    var variableName = nodeData.indicatorLightSettings.settings.variableName;
                    if (null != variableName && variableName.length > 0) {
                        variableNames.push(variableName);
                    }
                }
                return variableNames;
        }
    };
    DiagramCompileService.prototype.elementFinished = function (obj, svg) {
        _.each(ElementFactory.allElements, function (el) { return el.handleElementFinished(obj, svg); });
        var part = obj;
        if (!part || !part.category) {
            return;
        }
        var $elt = $(svg);
        var element = ElementFactory.allElements.find(function (e) { return e.getCategoryKey() === part.category; });
        if (element) {
            var model = element.build(part, $elt);
            $elt.attr('data-model', JSON.stringify(model));
        }
    };
    DiagramCompileService = __decorate([
        Injectable()
    ], DiagramCompileService);
    return DiagramCompileService;
}());
export { DiagramCompileService };
